// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Pqb3c","loadingWrap":"styles_loadingWrap__Sbxdk","noData":"styles_noData__SY4W2","noDataIcon":"styles_noDataIcon__jwti4","viewBtn":"styles_viewBtn__1kuFR"};